var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgItem16B(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      enableBackground: "new 0 0 750 289"
    },
    viewBox: "0 0 750 289",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M750 0H0v289.4h750V0z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.3 153.4v-40.7h-77.1v40.7h77.1z",
    style: {
      fill: "#fff"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M256 154.2v-42h-78.4v42H256m-1.3-40.7v39.3h-75.8v-39.3h75.8z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M256 194.3v-40.4h-77.1v40.4H256z",
    style: {
      fill: "#666"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M256 194.3v-41.7h-78.4v41.7H256m-1.3-40.4V193h-75.8v-39.1h75.8z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M232.3 85.3v-4.1h-31.1v4.1h2.5V95c0 1.5-.8 3.1-2.6 4.7-3 2.6-6.7 4.8-11.1 6.6-4.5 1.8-8.2 2.7-10.9 2.8h-.3l-.1.1c-1.8.5-2.8 1.7-3 3.6V196h81.8v-83.2c-.2-1.9-1.2-3.1-3-3.6l-.1-.1h-.3c-1.8 0-4-.5-6.7-1.3-4.3-1.4-8.3-3.2-12.1-5.7-1.8-1.1-3.2-2.3-4.2-3.6-1.1-1.3-1.6-2.5-1.6-3.6v-9.7l2.8.1m-1.3-2.7V84h-2.5v11.1c0 2 1.1 3.9 3.2 5.7 3 2.8 6.8 5.1 11.4 6.8 4.3 1.7 8 2.7 11.1 2.9h.1c1.3.3 2 1.1 2.1 2.4v81.8h-79.2v-81.8c.1-1.3.8-2.1 2.1-2.4h.3c1.8-.1 4.1-.6 6.7-1.4 4.4-1.3 8.5-3.2 12.4-5.7 1.8-1.3 3.4-2.6 4.6-3.9 1.2-1.4 1.8-2.9 1.8-4.3V84h-2.5v-1.4H231z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m226.6 88.5 1.6-3.9h-22.8l1.1 3.9h20.1z",
    style: {
      fill: "#7f7f7f"
    }
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M210.2 124.7h-2.6l-1.1 5.4-.9-5.4h-2.4l-1.1 5.3-1.1-5.3h-2.5l2.2 8.6h2.6l.8-5.3h.1l.9 5.3h2.5l2.6-8.6zm6.1 4.5c.5-1.4-.5-2.2-2.9-2.4-1.7-.2-2.8.5-3.2 2h2.2c-.1-.4.2-.6.8-.7.4 0 .7.2.8.7 0 .3-.3.5-.7.5-1.8-.2-2.9.5-3.4 2.1.1 1.2.8 1.8 2.1 1.8.8.1 1.5-.2 2-.8h.1v.7h2.4c-.2-.4-.3-.9-.3-1.4l.1-2.5m-3.2 2.6c-.5 0-.8-.2-.8-.5 0-.4.3-.6.8-.7.4-.1.7-.2.9-.3v.5c0 .8-.3 1.1-.9 1zm7.2-4.9v-1.8H218v1.8h-1.1v1.4h1.1v2.9c.3 1.5 1 2.1 2.1 1.8h1.6v-1.8h-.5c-.6 0-.8-.3-.8-.8v-2.1h1.3v-1.4h-1.4zm6.2 4.4c-.2.3-.6.4-1.1.4-.7 0-1.1-.4-1.2-1.2h4.6c.1-2.4-1.1-3.6-3.6-3.7-2.1.2-3.2 1.3-3.3 3.2.2 2.1 1.4 3.2 3.6 3.3 1.4 0 2.5-.7 3.2-2h-2.2m-2.2-2c.1-.7.6-1.1 1.3-1.1.6.1.9.4.9 1.1h-2.2zm10.2-.3v-2.1h-.8c-.7 0-1.3.4-1.7 1.1v-1h-2.2v6.2h2.4v-2.5c0-1.3.5-1.9 1.4-1.8.4 0 .7 0 .9.1zm-17.2 40.1c-.2-2.7-1.6-4.1-4.2-4.3-2.8.2-4.2 1.7-4.3 4.3.1 2.8 1.6 4.3 4.3 4.5 2.6-.2 4-1.7 4.2-4.5m-2.6 0c-.2 1.7-.7 2.5-1.6 2.4-.9.1-1.5-.7-1.7-2.4.2-1.7.8-2.4 1.7-2.2.8-.2 1.4.6 1.6 2.2zm6.2 4.3v-6.1h-2.4v6.1h2.4m0-6.7V165h-2.4v1.7h2.4zm3.6 6.7V165h-2.4v8.4h2.4z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M413.9 153.5v-40.7h-77.2v40.7h77.2z",
    style: {
      fill: "#666"
    }
  }), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M414.6 154.2v-42H336v42h78.6m-1.4-40.7v39.3h-75.9v-39.3h75.9z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M413.9 193.6v-40.4h-77.2v40.4h77.2z",
    style: {
      fill: "#fff"
    }
  }), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M414.6 194.3v-41.7H336v41.7h78.6m-1.4-40.4V193h-75.9v-39.1h75.9z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M388.2 85.3h2.5v-4.1h-31.1v4.1h2.6V95c-.1 1.5-1 3.1-2.8 4.7-2.9 2.6-6.6 4.8-11.1 6.6-4.5 1.8-8.1 2.7-10.8 2.8h-.4l-.1.1c-1.8.5-2.7 1.7-2.8 3.6V196h81.7v-83.2c-.1-1.9-1.1-3.1-2.9-3.6l-.1-.1h-.3c-1.7 0-3.9-.5-6.7-1.3-4.2-1.4-8.2-3.2-12.1-5.7-1.8-1.1-3.2-2.3-4.2-3.6-1.1-1.3-1.6-2.5-1.6-3.6v-9.6m1.4-2.7V84h-2.5v11.1c.1 2 1.2 3.9 3.2 5.7 3.1 2.8 6.9 5.1 11.4 6.8 4.4 1.7 8.1 2.7 11.1 2.9h.3c1.2.3 1.8 1.1 2 2.4v81.8h-79.1v-81.8c0-1.3.7-2.1 2-2.4h.3c1.9-.1 4.2-.6 6.8-1.4 4.3-1.3 8.5-3.2 12.4-5.7 1.8-1.3 3.4-2.6 4.6-3.9 1.1-1.4 1.8-2.9 1.8-4.3V84H361v-1.4h28.4z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m385.1 88.5 1.7-3.9h-22.9l1.1 3.9h20.1z",
    style: {
      fill: "#7f7f7f"
    }
  }), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M375.8 128.7c-.1-2.7-1.6-4.2-4.3-4.3-2.8.2-4.2 1.6-4.3 4.3.1 2.8 1.6 4.3 4.3 4.5 2.8-.2 4.2-1.7 4.3-4.5m-2.6 0c-.3 1.8-.8 2.5-1.7 2.4-.9.2-1.5-.6-1.7-2.4.2-1.7.8-2.4 1.7-2.2.9-.2 1.4.6 1.7 2.2zm6.1 4.6v-6.2h-2.4v6.2h2.4m0-6.9v-1.7h-2.4v1.7h2.4zm3.7 6.9v-8.6h-2.4v8.6h2.4zM368.6 165h-2.5l-1.1 5.3h-.1l-.9-5.3h-2.4l-.9 5.3-1.1-5.3H357l2.4 8.4h2.5l.9-5.1.9 5.1h2.5l2.4-8.4zm6.2 4.6c.5-1.4-.5-2.2-2.9-2.5-1.8-.2-2.9.5-3.3 2.1h2.2c-.1-.4.2-.6.9-.7.5 0 .7.2.8.5-.1.4-.3.5-.7.5-1.8-.1-3 .6-3.6 2.1.1 1.3.9 1.9 2.2 1.8.8 0 1.4-.2 2-.7 0 .2 0 .4.1.5h2.4c-.2-.4-.3-.9-.3-1.3v-2.3m-3.1 2.6c-.5 0-.7-.2-.8-.5 0-.5.4-.7.9-.7.3-.1.6-.3.9-.4v.7c-.1.7-.5 1-1 .9zm7.4-4.7v-2h-2.4v2h-1.1v1.4h1.1v2.9c.2 1.4.9 2.1 2.1 1.8.4 0 .9-.1 1.4-.1v-1.7h-.5c-.5 0-.7-.3-.7-.8v-2.1h1.2v-1.4h-1.1zm4.9-.4c-2 .2-3 1.3-3.2 3.3.1 2.1 1.3 3.2 3.4 3.2 1.5 0 2.6-.6 3.2-1.8H385c-.2.3-.5.4-.9.4-.8-.1-1.2-.5-1.2-1.2h4.5c0-2.5-1.2-3.8-3.6-3.9m.2 1.6c.7 0 1.1.4 1.1 1.1h-2.2c.1-.7.5-1.1 1.1-1.1zm8.9-1.5c-.2 0-.4-.1-.7-.1-.8 0-1.4.4-1.7 1.2v-.9h-2.4v6.1h2.4V171c0-1.3.5-1.9 1.4-1.8.4 0 .7 0 .9.1v-2.1h.1z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M572.3 112.8h-77.1v81h77.1v-81z",
    style: {
      fill: "#999"
    }
  }), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M494.5 194.6H573v-82.4h-78.4v82.4m1.3-1.4v-79.7h75.8v79.7h-75.8z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M546.6 85.3h2.6v-4.1h-31.1v4.1h2.5V95c0 1.5-.9 3.1-2.8 4.7-2.9 2.6-6.6 4.8-11.1 6.6-4.4 1.8-8 2.7-10.8 2.8h-.3l-.1.1c-1.8.5-2.8 1.7-2.9 3.6V196h81.7v-83.2c-.1-1.9-1.1-3.1-2.8-3.6l-.1-.1h-.3c-1.8 0-4-.5-6.8-1.3-4.3-1.4-8.2-3.2-12-5.7-1.8-1.1-3.3-2.3-4.3-3.6-1.1-1.3-1.6-2.5-1.6-3.6v-9.6m1.5-2.7V84h-2.6v11.1c.1 2 1.2 3.9 3.2 5.7 3.2 2.8 7 5.1 11.4 6.8 4.3 1.7 8 2.6 11.1 2.8v.1h.3c1.3.3 1.9 1.1 2 2.4v81.8h-79.1v-81.8c.1-1.3.8-2.1 2-2.4h.3c1.9-.1 4.2-.6 6.8-1.4 4.3-1.3 8.4-3.2 12.4-5.7 1.9-1.3 3.4-2.6 4.6-3.9 1.2-1.4 1.8-2.9 1.8-4.3V84h-2.5v-1.4h28.3z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m543.5 88.5 1.7-3.9h-22.9l1.2 3.9h20z",
    style: {
      fill: "#7f7f7f"
    }
  }), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M526.9 140.6h-2.5l-1.1 5.3h-.1l-.9-5.3H520l-.9 5.3h-.1l-.9-5.3h-2.6l2.4 8.4h2.5l.9-5.1.9 5.1h2.5l2.2-8.4zm3.8 4.1c0 .4-.2.5-.5.5-1.8-.1-3 .6-3.6 2.1.1 1.3.9 1.9 2.2 1.8.7 0 1.4-.2 2-.7v.5h2.5c-.2-.4-.3-.9-.3-1.3v-2.5c.5-1.4-.5-2.2-3-2.5-1.7-.2-2.8.5-3.2 2.1h2.2c-.1-.4.2-.6.9-.7.5.2.8.4.8.7m-.9 1.9c.4 0 .7-.1.9-.3v.7c0 .6-.4.9-.9.9-.4 0-.7-.2-.8-.5 0-.5.3-.7.8-.8zm8.6-2.2v-1.3H537v-2h-2.2v2h-1.1v1.3h1.1v3c.2 1.4.8 2.1 2 1.8.5 0 1.1-.1 1.6-.1v-1.7h-.5c-.6 0-.9-.3-.8-.8v-2.2h1.3zm3.6-1.6c-2 .2-3.1 1.3-3.2 3.3.2 2.1 1.3 3.2 3.4 3.2 1.4 0 2.5-.6 3.2-1.8h-2.2c-.2.3-.5.4-.9.4-.8-.1-1.2-.5-1.2-1.2h4.5c0-2.5-1.2-3.8-3.6-3.9m.2 1.6c.6 0 1 .4 1.1 1.1H541c.2-.7.6-1.1 1.2-1.1zm9-1.5c-.2 0-.4-.1-.7-.1-.9 0-1.5.4-1.7 1.2h-.1v-.9h-2.2v6.1h2.4v-2.4c0-1.3.5-1.9 1.4-1.8.4 0 .7 0 .9.1v-2.2zm-25.3 17.7c.5-.6.8-1.2.9-2h-2c0 .2-.1.4-.3.5l-.7-.8c.9-.4 1.4-1.1 1.6-2.1-.1-1.5-1.1-2.3-2.8-2.2-1.4 0-2.2.8-2.5 2.2 0 .6.3 1.1.7 1.4-1.1.5-1.7 1.3-1.8 2.5.1 1.7 1.1 2.5 2.9 2.6.9 0 1.7-.2 2.4-.8l.5.7h2.8l-1.7-2m-2.3-4.4c0 .4-.3.7-.8.9-.2-.3-.4-.6-.5-.9.1-.3.3-.5.7-.5s.6.1.6.5m-2.3 4c.1-.4.4-.7.8-.9l1.1 1.2c-.3.3-.6.5-1.1.5-.4 0-.7-.2-.8-.8zm19.2-1.7c-.1-2.8-1.6-4.3-4.3-4.5-2.7.2-4.1 1.7-4.2 4.5.1 2.7 1.5 4.1 4.2 4.3 2.7-.2 4.1-1.6 4.3-4.3m-2.7 0c-.2 1.7-.8 2.4-1.7 2.2-.9.2-1.4-.6-1.7-2.2.3-1.8.8-2.6 1.7-2.4.9-.1 1.5.7 1.7 2.4zm6 4.3v-6.2h-2.4v6.2h2.4m0-6.9v-1.6h-2.4v1.6h2.4zm3.8 6.9v-8.4h-2.2v8.4h2.2z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M587.8 207.6v-12.4H162.1v12.4h425.7z",
    style: {
      fill: "#bfbfbf"
    }
  }), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M588.5 208.3v-13.7h-427v13.7h427m-1.3-12.3v11H162.8v-11h424.4z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M225.2 215.8c-2.4-2.4-5.2-3.6-8.6-3.6-3.4 0-6.3 1.2-8.7 3.6-2.4 2.4-3.6 5.3-3.6 8.7s1.2 6.3 3.6 8.7c2.4 2.4 5.3 3.6 8.7 3.6s6.2-1.2 8.6-3.6c2.4-2.4 3.6-5.3 3.6-8.7s-1.2-6.3-3.6-8.7z",
    style: {
      fill: "#369",
      fillOpacity: 0.502
    }
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(.9981 0 0 1 212.667 229.368)",
    style: {
      fontSize: "11.4815px",
      fontFamily: "'ArialMT'",
      fill: "#fff"
    }
  }, "\n    1\n  "), /*#__PURE__*/React.createElement("path", {
    d: "M383.7 215.8c-2.4-2.4-5.2-3.6-8.6-3.6s-6.3 1.2-8.7 3.6c-2.4 2.4-3.6 5.3-3.6 8.7s1.2 6.3 3.6 8.7 5.3 3.6 8.7 3.6c3.4 0 6.2-1.2 8.6-3.6 2.4-2.4 3.6-5.3 3.6-8.7 0-3.4-1.2-6.3-3.6-8.7z",
    style: {
      fill: "#369",
      fillOpacity: 0.502
    }
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(.9981 0 0 1 371.217 229.368)",
    style: {
      fontSize: "11.4815px",
      fontFamily: "'ArialMT'",
      fill: "#fff"
    }
  }, "\n    2\n  "), /*#__PURE__*/React.createElement("path", {
    d: "M544.6 215.8c-2.4-2.4-5.2-3.6-8.6-3.6-3.4 0-6.3 1.2-8.7 3.6-2.4 2.4-3.6 5.3-3.6 8.7s1.2 6.3 3.6 8.7c2.4 2.4 5.3 3.6 8.7 3.6s6.2-1.2 8.6-3.6c2.4-2.4 3.6-5.3 3.6-8.7 0-3.4-1.2-6.3-3.6-8.7z",
    style: {
      fill: "#369",
      fillOpacity: 0.502
    }
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(.9981 0 0 1 532.117 229.368)",
    style: {
      fontSize: "11.4815px",
      fontFamily: "'ArialMT'",
      fill: "#fff"
    }
  }, "\n    3\n  "));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgItem16B);
export default __webpack_public_path__ + "static/media/item16b.9720ed4251c066220bc6f7baf250ea53.svg";
export { ForwardRef as ReactComponent };